import Locale from "../i18n/Locale";

export function currentCulture(): Locale {
	return Locale.getCurrent();
}
